import { createAction, props } from '@ngrx/store';

import { MultiUserPreferences } from 'app/features/settings/models';
import { SortActivityMode } from 'app/shared/models';

export const resetMultiUserPreferences = createAction('[Multi-User Preferences] Reset');

export const updatingMultiUserRecentEmployeeNumber = createAction(
    '[Multi-User Preferences] Updating Recent Employee Number',
    props<{ employeeNumber: number }>(),
);

export const updatingMultiUserRecentActivities = createAction(
    '[Multi-User Preferences] Updating Recent Activities',
    props<{ activityNumber: number }>(),
);
export const updatingSortActivityModeInMultiUserPreferences = createAction(
    '[Multi-User Preferences] Updating Sort Activity Mode',
    props<{ sortActivityMode: SortActivityMode }>(),
);

export const updatingMultiUserRecentProductBoxNumber = createAction(
    '[Multi-User Preferences] Updating Recent Product Box Number',
    props<{ recentProductBoxNumber: number }>(),
);
export const initializingMultiUserPreferenceStore = createAction('[Multi-User Preferences] Initializing');
export const initializedMultiUserPreferenceStore = createAction(
    '[Multi-User Preferences] Initialized',
    props<{ preferences: MultiUserPreferences }>(),
);
